import React from "react";

const CustomImage = ({
  serviceImageHandle,
  setSelectedFile,
  setImagePreview,
  imagePreview,
  imageName,
  imageCount,
  downloadNow,
}) => {
  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      {imagePreview ? (
        <>
          <div
            className="mx-auto"
            style={{ position: "relative", width: "100px" }}
          >
            <img
              src={imagePreview}
              alt="Preview"
              style={{
                width: "100px",
                height: "100px",
                background: "#eee",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            />
            <button
              className="btn btn-danger btn-sm btn-icon"
              onClick={() => {
                setImagePreview(null);
                setSelectedFile(null);
              }}
              style={{
                position: "absolute",
                top: 5,
                right: 5,
                fontSize: "8px",
                padding: "2px",
                width: "20px",
                height: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
            {downloadNow && (
              <a
                target="_blanl"
                href={imagePreview}
                className="btn btn-success btn-sm btn-icon"
                style={{
                  position: "absolute",
                  top: 5,
                  left: 5,
                  fontSize: "8px",
                  padding: "2px",
                  width: "20px",
                  height: "20px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <i className="fa fa-save"></i>
              </a>
            )}
          </div>
        </>
      ) : (
        <>
          <label
            className="mx-auto mb-0"
            htmlFor={imageCount ? imageCount : "selectImg"}
            style={{
              width: "100px",
              height: "100px",
              background: "#eee",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "12px",
              cursor: "pointer",
              border: "1px dashed #444",
            }}
          >
            Select Image
          </label>
          <input
            type="file"
            id={imageCount ? imageCount : "selectImg"}
            className="form-control d-none"
            accept="image/*"
            onChange={serviceImageHandle || handleFileInputChange}
          />
        </>
      )}
      {imageName && <small>{imageName}</small>}
    </>
  );
};

export default CustomImage;
